import { TableCell } from './TableCell'
import { TableCellButton } from './TableCellButton'
import { TableCellIcon } from './TableCellIcon'
import { TableCellText } from './TableCellText'
import { TableHeader } from './TableHeader'
import { TableRoot } from './TableRoot'
import { TableRow } from './TableRow'

export type { TableCellProps } from './TableCell'
export type { TableCellButtonProps } from './TableCellButton'
export type { TableCellIconProps } from './TableCellIcon'
export type { TableCellTextProps } from './TableCellText'
export type { TableHeaderProps } from './TableHeader'
export type { TableRootProps } from './TableRoot'
export type { TableRowProps } from './TableRow'
export type { Order, UseColumnOrderParams, UseColumnOrder } from './libs/useColumnOrder'

export { useColumnOrder } from './libs/useColumnOrder'

export const Table = {
  Cell: TableCell,
  CellButton: TableCellButton,
  CellIcon: TableCellIcon,
  CellText: TableCellText,
  Header: TableHeader,
  Root: TableRoot,
  Row: TableRow,
}
